import script from "./LanguageDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./LanguageDropdown.vue?vue&type=style&index=0&id=a165c332&scoped=true&lang=css"
import "./LanguageDropdown.vue?vue&type=style&index=1&id=a165c332&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a165c332"]])

export default __exports__